import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import TemplateEPLView from './template-epl-view';
import TemplateEPLAdd from './template-epl-add';
import TemplateEPLCopyAlert from './template-epl-copy-alert';

import isEmpty from 'lodash/isEmpty';
import SelectSingleTag from 'components/SingleSelect';

import * as ProjectActionType from 'Projects/constants';

import copy_icon from 'assets/img/copy-icon.png';

class TemplateEPLList extends Component {

  static propTypes = {
    DefaultTemplateList: PropTypes.array,
    projectId: PropTypes.string,
    selectCustomTemplate: PropTypes.func,
    selectDefaultTemplate: PropTypes.func,
    getDefaultTemplate: PropTypes.func,
    getCustomTemplateDetail: PropTypes.func,
    customTemplateList: PropTypes.object,
    onEditCustomTemplate: PropTypes.func,
    onDuplicateEOCTemplate: PropTypes.func,
    onCopyEOFTemplate: PropTypes.func,
    ProjectListCopy: PropTypes.array,
    onFetchProject: PropTypes.func,
    RequestTypeToMappingList: PropTypes.object,
    dispatch: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.state = {
      checked: false,
      templateId: null,
      isOpenCreateModal: false,
      isOpenViewModal: false,
      onlyView: false,
      ctxMenuList: {},
      ctxMenuCopy: {},
      requestTypeList: {},
      options: [{ name: 'Text1', id: 'Value1' }, {name: 'Text2', id: 'Value2'}]
    };
  }

  componentDidMount() {
    window.addEventListener('click', e => {
      if (document.getElementById('box') && document.getElementById('box').contains(e.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (document.getElementById('context-menu-eof') && document.getElementById('context-menu-eof').contains(e.target)) {
          // clicked in box
        } else {
          this.setState({ selectedId: null });
        }
      }
    });

    this.props.onFetchProject({projectId: this.props.projectId});
  }

  componentWillReceiveProps = (nextProps) => {
    if (this.props.DefaultTemplateList !== nextProps.DefaultTemplateList) {
      let result = nextProps.DefaultTemplateList.reduce((agg, item) => {
        if (item.requestType !== null) {
          agg[item.id] = item.requestType;
        }
        return agg;
      }, {});

      this.setState({requestTypeList: result});
    }

    if (this.props.RequestTypeToMappingList !== nextProps.RequestTypeToMappingList) {
      this.setState({RequestTypeToMappingList: nextProps.RequestTypeToMappingList});
    }
    // RequestTypeToMappingList
  }

  componentWillUnmount() {
    // const self = this;
    window.removeEventListener('click', e => {
      if (
        document.getElementById('box') &&
        document.getElementById('box').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('context-menu-eoc') &&
          document.getElementById('context-menu-eoc').contains(e.target)
        ) {
          // clicked in box
        } else {
          this.setState({ ctxMenuList: {}, ctxMenuCopy: {} });
        }
      }
    });
  }

  viewTemplate = (id) => {
    this.setState({
      isOpenViewModal: true,
      onlyView: false,
      templateId: id
    });
  }

  onClose = () => {
    this.setState({
      isOpen: false
    });
  }

  onCheckedCustomTemplate = (id) => {
    const {projectId} = this.props;
    this.props.selectCustomTemplate({
      projectId: projectId,
      templateId: id
    }, () => this.props.getDefaultTemplate());
  }

  onCheckedDefaultTemplate = (id) => {
    const {projectId} = this.props;
    this.props.selectDefaultTemplate({
      projectId: projectId,
      templateId: id
    }, () => this.props.getDefaultTemplate());
  }

  onDuplicateEOC = (id) => {
    const {projectId} = this.props;
    this.props.onDuplicateEOCTemplate({
      projectId: projectId,
      templateId: id
    }, () => this.setState({ctxMenuList: {}},
      () => this.props.getDefaultTemplate()));
  }

  compareData = (a, b) => {
    const typeA = a.name;
    const typeB = b.name;

    if (typeA > typeB) {return 1;}

    if (typeB > typeA) {return -1;}

    return 0;
  }

  removeRequestType = (itemId, selectedRequestType) => {
    let { requestTypeList } = this.state;

    requestTypeList[itemId] = null;
    this.setState({requesTypeList: requestTypeList});

    this.props.dispatch({
      type: ProjectActionType.DELETE_REQUEST_TYPE_TEMPLATE_ASYNC,
      params: {
        requestTypeId: selectedRequestType.id
      },
      callback: () => {
        this.setState({RequestTypeToMappingList: []});
      }
    });
  }

  changeRequestType = (itemId, selectedRequestType) => {
    let { requestTypeList } = this.state;

    this.props.dispatch({
      type: ProjectActionType.POST_REQUEST_TYPE_TEMPLATE_ASYNC,
      params: {
        templateId: itemId,
        requestTypeId: selectedRequestType ? selectedRequestType.id : null
      },
      callback: (data) => {
        selectedRequestType.id = data ? data : selectedRequestType.id;
        requestTypeList[itemId] = selectedRequestType;

        this.setState({RequestTypeToMappingList: [], requestTypeList: requestTypeList});
      }
    });
  }

  onClickCopyIcon = (e, itemId) => {
    e.stopPropagation();

    if (itemId !== this.state.selectedId) {
      this.setState({selectedId: itemId });
    }
    else {
      this.setState({selectedId: null });
    }
  }

  renderSystemTemplateItem = (items) => {
    let systemItems = (items || []);

    return (
      <React.Fragment>
        <div className='row'>
          <div className='col-md-12'>
            <span className='bolder-header'>Customized templates</span>
            <button className='btn btn-primary btn-siteone-default' style={{marginLeft: 10}} onClick={() => this.setState({ isOpenCreateModal: true})}>
              <span className='fa fa-plus icon' /> Add</button>
          </div>
        </div>
        {
          Array.isArray(systemItems) && systemItems.length > 0 &&
          systemItems.sort((a,b) => a.name.localeCompare(b.name)).map((item, index) =>
            <div key={index} id='box' className='box-selection row' style={{marginLeft: 0, borderRadius: '5px 5px', display: 'flex', alignItems: 'center'}} >
              <div className='items col-md-7 col-lg-8' onClick={() => this.viewTemplate(item.id)}>
                <span className='title'>{item.name}</span>
                <div>
                  <span className='default-color-create-by'>Created by&nbsp;</span>
                  <span className='default-color-creator'>{item.formCreatedByUser}</span>
                </div>
              </div>
              <div className='items col-md-5 col-lg-4' style={{display: 'flex', alignItems: 'center', paddingRight: 40}}>
                <SelectSingleTag
                  style={{display: 'inline-block', width: 180}}
                  placeholder='Add new request type...'
                  value={this.state.requestTypeList[item.id]}
                  options={this.state.RequestTypeToMappingList}
                  onChange={(e) => this.changeRequestType(item.id, e)}
                  onRemove={() => this.removeRequestType(item.id, this.state.requestTypeList[item.id])}
                  onRemote={() => this.onLoadRequestType(item)}
                  getOptionValue={(option) => option.id}
                  getOptionLabel={(option) => option.name}/>
                <div style={{position: 'absolute', right: 10, cursor: 'pointer'}} onClick={e => this.onClickCopyIcon(e, item.id)}>
                  <img src={copy_icon} style={{width: 32}} />
                </div>
                {
                  this.state.selectedId === item.id &&
                    <ul className='second-level-menu' id='context-menu-eof' style={{padding: 0}}>
                      {
                        isEmpty(this.props.ProjectListCopy)
                          ? <span className='contextMenuCopyNoResults'>
                            <li className='contextMenuCopyNoResults--option'>(No Results Found)</li>
                          </span>
                          : <span className='contextMenuCopy'>
                            {
                              this.props.ProjectListCopy.sort(this.compareData).map(project =>
                                <li key={project.id} onClick={() => { this.onCopyEOF(project.name, project.id, item.id);}} className='contextMenuCopy--option'>
                                  {project.name}
                                </li>
                              )}
                          </span>
                      }
                    </ul>
                }
              </div>
            </div>
          )
        }
      </React.Fragment>
    );
  }

  onCopyEOF = (projectName, projectId, templateId) => {
    this.setState({
      projectName: projectName,
      requestTypeName: this.state.requestTypeList[templateId] && this.state.requestTypeList[templateId].name
    },
    () => this.props.onCopyEOFTemplate({
      templateId: templateId,
      targetProjectId: projectId
    },
    (isSuccess) => {
      if (isSuccess) {
        this.setState({ selectedId: null }, () => this.props.getDefaultTemplate());
      }
      else {
        this.setState({ selectedId: null, openAlertModal: true });
      }
    })
    );
  }

  onOK = () => {
    this.setState({ openAlertModal: false });
  }

  onLoadRequestType = (item) => {
    this.props.dispatch({
      type: ProjectActionType.GET_REQUEST_TYPE_TO_MAPPING_ASYNC,
      params: {
        projectId: this.props.projectId
      }
    });
  }

  render() {
    let { isOpenCreateModal, isOpenViewModal } = this.state;

    return (

      <React.Fragment>
        { this.renderSystemTemplateItem(this.props.DefaultTemplateList) }
        {
          isOpenCreateModal &&
          <TemplateEPLAdd
            builderName={this.state.builderName}
            getDefaultTemplate={this.props.getDefaultTemplate}
            onClose={() => { this.setState({isOpenCreateModal: false});}}
            projectId={this.props.projectId}/>
        }
        {
          isOpenViewModal &&
          <TemplateEPLView
            onlyView={this.state.onlyView}
            customTemplateList={this.props.customTemplateList}
            templateId={this.state.templateId}
            projectId={this.props.projectId}
            getCustomTemplateDetail={this.props.getCustomTemplateDetail}
            getDefaultTemplate={this.props.getDefaultTemplate}
            onClose={() => { this.setState({isOpenViewModal: false});}}
            onSave={this.props.onEditCustomTemplate}/>
        }
        {
          <TemplateEPLCopyAlert
            isOpen={this.state.openAlertModal}
            onOK={this.onOK}
            requestTypeName={this.state.requestTypeName}
            projectName={this.state.projectName} />
        }
      </React.Fragment>
    );
  }

}

const mapStateToProps = (state) => {
  return {
    RequestTypeToMappingList: state.ProjectStore.RequestTypeToMappingList
  };
};

export default connect(mapStateToProps)(TemplateEPLList);



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/template-epl-list.js